
import { defineComponent, ref, reactive, onMounted, inject } from 'vue'
import { FormInstance, FormRules, ElNotification } from "element-plus";
//services
import acrdService from "@/core/services/AcrdService";
import sportService from "@/core/services/SportService"
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "step-competition",
    props: {
        idacrd: {
            type: String,
            required: true,
            default: ""
        },
        idevent: {
            type: String,
            required: true,
            default: ""
        },
        idsport: {
            type: String,
            required: true,
            default: ""
        }
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const loadingTest = ref(false)
        const formRef = ref<FormInstance>()
        const form = reactive(<any>{
            idteam: '',
            idtest: null,
            target: 'competition'
        })
        const rules = reactive<FormRules>({})
        const listSetting = ref<any>([])
        const listTest = ref<any>([])
        const listMiTest = ref<any>([])
        const rowAcrd = inject<any>('rowAcrd') //obtener la preinfo que será asignada a la etiqueta for

        const getSetting = async () => {
            await sportService.getParams({
                idevent: props.idevent,
                idsport: props.idsport
            }).then((res) => {
                //console.log(res.data)
                listSetting.value = res.data
                //console.log(form.idteam = listSetting.value.cmp[0].id)
                //console.log(form.idteam)
                if (res.data) {
                    //asignar el primer registro
                    //form.idteam = listSetting.value.cmp[0].id
                }
                
            }).catch(({ response }) => {
                errManager(response)
            })
        }

        //obtener la lista de pruebas segun la modalidad
        const getTest = async () => {
            loader.value = true
            form.idtest = null
            if (form.idteam != '') {
                listTest.value = []
                await sportService.getTest({
                    idevent: props.idevent,
                    idsport: props.idsport,
                    cmp: form.idteam,
                    nivel: form.idniv,
                    gender: rowAcrd.value.gender ?? form.gender,
                }).then((res) => {
                    listTest.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
            }
        }

        const saveTest = async () => {
            if (form.idtest != null) {
                loadingTest.value = true
                await acrdService.saveTestAtlete({
                    idevent: props.idevent,
                    idsport: props.idsport,
                    idacrd: props.idacrd,
                    idcmp: form.idteam,
                    idniv: form.idniv,
                    idtest: form.idtest,
                    idcat: rowAcrd.value.gender ?? form.gender,
                    param1: form.param1,
                }).then((res) => {
                    loadingTest.value = false
                    if (res.data.status == 'success') {
                        form.idtest = null
                        getMiTests()
                    }
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loadingTest.value = false
                    errManager(response)
                })
            } else {
                ElNotification({
                    title: process.env.VUE_APP_NAME,
                    message: 'Falta seleccionar la prueba a agregar',
                    type: 'error',
                })
            }


        }

        //mis pruebas marcadas
        const getMiTests = async () => {
            loadingTest.value
            await acrdService.getAtletaTest({
                id: props.idacrd
            }).then((res) => {
                loadingTest.value = false
                listMiTest.value = res.data
            }).catch(({ response }) => {
                loadingTest.value = false
                errManager(response)
            })
        }

        const getAcrd = async () => {
            loader.value = true
            await acrdService.getAcreditation(props.idacrd, 'show')
                .then((res) => {
                    Object.assign(form, res.data.info, res.data.person)
                    if(props.idsport == '12' || props.idsport == '14'){
                        form.idteam = ''
                    }
                    
                    
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onDeleteTest = async (idtest) => {
            loadingTest.value = true
            acrdService.deleteTestAtlete({ idtest: idtest })
                .then((res) => {
                    loadingTest.value = false
                    getMiTests()
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loadingTest.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getSetting()
            //getTest()
            getMiTests()
            if (props.idacrd)
                getAcrd()
        })

        return {
            t,
            loader,
            loadingTest,
            formRef,
            form,
            rules,
            listSetting,
            listTest,
            listMiTest,
            rowAcrd,

            //events
            getSetting,
            getTest,
            saveTest,
            getMiTests,
            onDeleteTest

        }

    },
})
